import React from "react";
import "./ReUsableSingleRoundTab.css";

function ReUseableAuditionHeaderTitle({ isPrimary, title }) {
  return (
    <div
      className={`${isPrimary ? "bgTeal" : "bgCyan"}`}
      style={{ borderRadius: 10 }}
    >
      <div className=" p-2  text-center">
        <h4
          className={`${
            isPrimary ? "fw-bold text-dark" : "fw-bold text-light"
          }`}
        >
          {" "}
          <i>{title}</i>
        </h4>
      </div>
    </div>
  );
}

export default ReUseableAuditionHeaderTitle;
